<div class="container">

  <app-header-dialog [iconName]="'noise_control_off'">
    Diretriz e Consenso
  </app-header-dialog>


  <div *ngIf="entityForm">

    <div class="content">

      <div style="margin-top: 10px;">
        <input type="file" #fileImage (change)="onFileSelected($event)" accept="image/*, application/pdf"
          style="display:none;">
        <a mat-raised-button (click)='fileImage.click()' matTooltip='Selecionar arquivo'
          style='background-color: whitesmoke;'>
          <mat-icon class='icon-add'>image_search</mat-icon>
          Selecionar arquivo
        </a>
      </div>

      <div style="margin: 20px 10px 10px 10px;">
        <span *ngIf="!selectedFileName">Nenhum arquivo selecionado</span>
        <span *ngIf="selectedFileName && !storedFile">{{selectedFileName}}</span>
        <a *ngIf="selectedFileName && storedFile" target="_blank" [href]="storedFile"
          style='background-color: whitesmoke;'>
          {{selectedFileName}}
        </a>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>Nome</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
          autocomplete="off">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Link</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.link"
          autocomplete="off">
      </mat-form-field>

    </div>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
      <button *ngIf="!isEdit" matTooltip='Inserir' mat-raised-button
        (click)="matDialogRef.close(['insert', entityForm, selectedFile])" [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>
      <button *ngIf="isEdit" matTooltip='Alterar' mat-raised-button (click)="matDialogRef.close(['update', entityForm, selectedFile])"
        [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>

    </div>

  </div>

</div>